<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'首页0'" :activeNames="'首页'"></PHeader>
		
		<article>
			<el-carousel style="height:330px;width:100%" :autoplay="true">
				<el-carousel-item v-for="item in imgList" :key="item.id+'lunbotu'" style="height:300px;width:100%;">
					<img :src="item.url" style="height: 100%;width: 100%;">
					<div class="fbannerUpText" :style="{position:'absolute',top:'30%',left:' 3%',color:'white','font-weight':600,'font-size':'20px'}" v-html="item.name"></div>
					<button class="fbannerBottomText" @click="toAboutUs()" :style="{position:'absolute',top:'45%',left:' 3%',color:'white','font-size':'12px',width:'80px',height:'30px','line-height':'30px','text-align':'center','background-color':'#98273A',border:'0','z-index':'999'}">了解更多</button>
				</el-carousel-item>
			</el-carousel>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;">关于我们</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">About Us</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div style="margin-left: 3%;margin-top: 20px;font-size: 14px;color: #8D8D8D;width: 94%;">上海和华利盛律师事务所经上海市司法局核准于2001年在上海市黄浦区成立，先后在重庆、西安、唐山、郑州、海口、太原、合肥设有分所，同时在香港、悉尼等地设有办公室或战略合作伙伴。</div>
			<div style="margin-left: 3%;margin-top: 20px;font-size: 14px;color: #8D8D8D;width: 94%;">中文名“和华利盛”:包含“和为贵”、“和谐中华”、“专注商业”、“繁荣昌盛”之义。英文名HAWORTH & LEXON：英语与拉丁文的组合，意为“法律之上的价值”。</div>
			<div style="margin-left: 3%;margin-top: 20px;font-size: 14px;color: #8D8D8D;width: 94%;">和华利盛自成立以来，积极学习国际、国内领先律所的先进运营经验，践行“专业、精致”的海派律师理念，以助力客户成长、成功为目标，以团队合作为基石，以专业化服务为依托，多年来，赢得了包括多家世界500强企业在内的众多客户的认可，在律师业和社会各界享有良好的声誉…</div>
			<div @click="toAboutUs()" style="margin-left: 3%;margin-top: 20px;font-size: 14px;border: 1px solid #BF4D40;width: 65px;color: #AA1100;text-align: center;padding: 5px 15px;border-radius: 50px;">了解更多</div>
			<div class="indexAboutUs" style="width:100%;height:100px;margin-top: 25px;">
				<div style="float: left;margin-left: 3%;margin-top: 25px;width: 70%;">
					<div style="font-size: 20px;font-weight: bolder;color: white;">
						业务领域
					</div>
					<div style="color: white;margin-top: 3px;font-size: 14px;">
						Business Area
					</div>
					<div style="margin-top: 3px;height: 3px;width: 20px;background-color: white;"></div>
				</div>
				<div style="float:left;width:10%;margin-top: 38px;">
					<img @click="toUpTable" style="width: 24px;height: 24px;border: 1px solid white;padding: 2px;border-radius: 30px;cursor: pointer;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/zuojiantou.png">
				</div>
				<div style="float:left;width:10%;margin-top: 38px;margin-left: 3%;">
					<img @click="toNextTable" style="width: 24px;height: 24px;border: 1px solid white;padding: 2px;border-radius: 30px;cursor: pointer;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/youjiantou.png">
				</div>
			</div>
			<div @click="toBusinessArea(item)" v-for="(item,index) in tableData" :key="item.id+index+'yewulingyu'" :style="{'border-bottom': '2px solid #B25D6B','text-align':'center',width:'48%',float:'left',height:'118px','margin-right':index%2 == 0?'4%':'0'}">
					<img :src="item.icon1" style="padding-top: 20px;height: 25px;">
					<div style="padding-top: 10px;font-size: 16px;font-weight: 100;">{{item.title}}</div>
					<div style="font-size: 12px;padding-top: 5px;color: #A4A4A4;">{{item.e_title}}</div>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:270px;">动态资讯</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Information Dynamics</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div v-for="(item,index) in articleData" :key="item.image+index+'dongtaizixun'" style="margin-top: 20px;height: 300px;margin-left: 3%;width: 94%;">
				<div style="width: 100%;height: 180px;">
					<img :src="item.image" style="width:100%;height:100%;">
				</div>
				<div style="margin-top: 5px;width: 100%;height: 40px;line-height: 40px;">
					<div @click="toNews(item)" style="float: left;width: 70%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 18px;font-weight: 600;">
						{{item.title}}
					</div>
					<div style="float: right;width: 30%;text-align: right;font-size: 14px;color: #98273A;">
						{{item.publish.substring(0,10)}}
					</div>
				</div>
				<div style="height: 66px;color: #595959;font-size: 14px;line-height: 22px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">
					{{item.description}}
				</div>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">合作伙伴</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Partners</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>

			
			<el-carousel class="parentCarousel" style="height:200px;width:97%;margin-left:3%;margin-top:0px;" :autoplay="true">
				<el-carousel-item v-for="(item,index) in parentList" :key="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(index+1)+'.png'" style="height:100%;width:100%;">
					<!-- <img v-for="item2 in item" :key="'img'+item2+index" :style="{'margin-top':'20px',float:'left','margin-right':item2%2 != 0?'2%':'0','margin-left':item2%2 == 0?'2%':'0',width: 'calc(30% - 2px)','line-height':'65px',height: '65px',border: '1px solid #EAEAEA'}" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(item2)+'.png'"> -->
					<img v-for="item2 in item" :key="'img'+item2+index" :style="{'margin-top':'20px',float:'left','margin-right':'3%',width: 'calc(30% - 2px)','line-height':'65px',height: '65px',border: '1px solid #EAEAEA'}" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(item2)+'.png'">

				</el-carousel-item>
			</el-carousel>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {queryImageByStatus} from "@/api/front";
	import {queryService} from "@/api/service";
	import {queryArticle} from "@/api/article";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				imgList: [],
				tableData: [],
				tablePage:1,
				totalPage:1,
				articleData:[],
				parentList:[
					[1,2,3,4,5,6],
					[7,8,9,10,11,12],
					[13,14,15,16,17,18],
					[19,20,21,22,23,24],
					[25,26,27,28,29,30],
					[31,32,33,34,35,36]
				]
			}
		},
		mounted() {
			this.queryBannerImage()
			this.tableList()
			this.queryArticle()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			toAboutUs(){
				this.$router.push(
					{
						path:'/phoneAboutUs',
					}
				);
			},
			toBusinessArea(item){
				this.$router.push(
					{
						path:'/phoneBusinessAreaDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			toNews(item){
				this.$router.push(
					{
						path:'/phoneNewsDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			queryBannerImage(){
				queryImageByStatus('N').then(data => {
					this.imgList=data.data.list
				}).catch(error =>{
					this.$message.error(error)
				})
			},
			toNextTable(){
				if(this.tablePage >= this.totalPage){
					this.tablePage = 1
				}else{
					this.tablePage += 1
				}
				this.tableList()
			},
			toUpTable(){
				if(this.tablePage <= 1){
					this.tablePage = this.totalPage
				}else{
					this.tablePage -= 1
				}
				this.tableList()
			},
			queryArticle(){
				let param = {
					page: 1,
					channelId: 13,
					pageSize:3,
					title:''
				}
				queryArticle(param).then(data => {
					this.articleData = data.data.list
					console.log('动态资讯')
					console.log(this.articleData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			tableList() {
				let param = {
					page: this.tablePage,
					pageSize: 4,
				}
				queryService(param).then(data => {
					this.tableData = data.data.list
					this.totalPage = Math.ceil(data.data.total/4)
					console.log(this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
</style>
